import { app } from '../../../../app';
import { Controller } from './administrator-audit.controller';

app.component('companyReportsAdministratorAudit', {
    bindings: {
        currentCompany: '<',
        logs$: '<',
    },
    controller: Controller,
    templateUrl: require('./administrator-audit.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/reports/administrator-audit/administrator-audit.component.js